/** 存储关于屏幕的一些操作 */
export default {
  /**
   * 全屏
   * @param el  需要全屏的dom，不传默认是body
   */
  full<T extends Element>(el?: T) {
    const e = el || document.body
    e.requestFullscreen()
  },
  /** 退出全屏 */
  exitFull: () => document.exitFullscreen()
  /** 判断当前浏览器是否全屏，可能会滥用，暂时不开放 */
  // isFull:   () => innerWidth === screen.width && innerHeight + 1 >= screen.height
}